import styled from "styled-components/macro";
import { listItems, selected } from "theme";

import extendedFieldHooks from "ExtendedFields/selectorHooks";

import FnrLabeledIcon from "UI/FnrLabeledIcon/FnrLabeledIcon";

import FieldDragList from "./FieldDragList/FieldDragList";
import OtherGroupList from "./OtherGroupList/OtherGroupList";

const SFnrLabeledIcon = styled(FnrLabeledIcon)`
  ${selected}
  ${listItems}
  ${({ theme }) => `
    border-top: 1px solid ${theme.colors.divider};
    border-bottom: 1px solid ${theme.colors.divider};
    `}
`;

const ExtendedFieldSelector = () => {
  const [fieldId] = extendedFieldHooks.useSelectedFieldId();
  const clearSelection = extendedFieldHooks.useClearSelection();
  const [, setIsNavigating] = extendedFieldHooks.useIsNavigating();
  const [fullWidth] = extendedFieldHooks.useDisplayIsFullWidth();

  const addingNewField = fieldId === undefined;

  const handleOnClick = () => {
    clearSelection();
    setIsNavigating(false);
  };

  return (
    <>
      <OtherGroupList />
      <FieldDragList />
      <SFnrLabeledIcon
        onClick={handleOnClick}
        data-cy="ExtendedFieldSelector_AddNew"
        icon="fa-plus-circle far"
        $selected={addingNewField && fullWidth}
      >
        Add a new field
      </SFnrLabeledIcon>
    </>
  );
};

export default ExtendedFieldSelector;
